import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useLowFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useLowFrequencyRefreshQuery.tsx';
import { CollaboratorApi } from '../../../apis/CollaboratorApi/CollaboratorApi.ts';
import { Collaborator } from '../Collaborator.ts';

export function useGetCollaboratorNew() {
    return useLowFrequencyRefreshQuery({
        queryKey: [QueryKeys.collaboratorNew],
        queryFn: async () => {
            const result = await CollaboratorApi.getCollaboratorNew();
            return result ? new Collaborator(result) : result;
        },
    });
}
